/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Title_AccentInputs */

const tr_landing_hero_title_accent = /** @type {(inputs: Landing_Hero_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zincirlerini kırın`)
};

const en_landing_hero_title_accent = /** @type {(inputs: Landing_Hero_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of e-commerce`)
};

const de_landing_hero_title_accent = /** @type {(inputs: Landing_Hero_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`des E-Commerce`)
};

const ru_landing_hero_title_accent = /** @type {(inputs: Landing_Hero_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`электронной коммерции`)
};

/**
* | output |
* | --- |
* | "of e-commerce" |
*
* @param {Landing_Hero_Title_AccentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_hero_title_accent = /** @type {((inputs?: Landing_Hero_Title_AccentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Title_AccentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_title_accent(inputs)
	if (locale === "de") return de_landing_hero_title_accent(inputs)
	if (locale === "ru") return ru_landing_hero_title_accent(inputs)
	return tr_landing_hero_title_accent(inputs)
});